import { statementsEnrollmentUrl } from "../api/endpoints.js";
import getFetchWrapper from "../api/getFetchWrapper.js";
const mutationFnFactory = (config, keyProps, headers = {}) => {
  const fetchWrapper = getFetchWrapper(config);
  return ({ enrollmentType, accountIdType }) => {
    return fetchWrapper(statementsEnrollmentUrl, {
      method: "PUT",
      body: JSON.stringify({
        "cipher.accountId": keyProps.accountId,
        accountIdType,
        enrollmentType
      }),
      headers
    });
  };
};
export { mutationFnFactory as default };
//# sourceMappingURL=mutation.js.map
